import CustomAction from "./CustomAction";

function Actions(action,
    showAlert,
    variables,
    setOpenVariable,
    variableRender,
    debuggingStart,
    debuggingExpand,
    automVersionId,
    automId,
    setVariables
) {
    if (action?.libraryLabel.includes('CUSTOM')) {
        return <CustomAction action={action} showAlert={showAlert} variableRender={variableRender} variables={variables}
            setOpenVariable={setOpenVariable} debuggingStart={debuggingStart}
            debuggingExpand={debuggingExpand} automVersionId={automVersionId} automId={automId} setVariables={setVariables} />
    }
}

export default Actions;
